<template>
  <div
    class="mb-horarios__dia-hora text-xs uppercase tracking-wider leading-none font-bold flex items-center gap-4"
  >
    <LucideClock :size="16" />

    <ClientOnly>
      <span class="mb-hora__weekday inline-flex min-w-[86px] justify-start">
        <NuxtTime weekday="long" locale="es-CL" :datetime="horaBase.date" />
      </span>
      <template #fallback>
        <span
          class="mb-hora__weekday flex h-12 min-w-[86px] rounded-xs bg-gray-900"
        ></span>
      </template>
    </ClientOnly>

    <LucideCircle :size="3" class="size-3!" />

    <ClientOnly>
      <span class="mb-hora__time inline-flex min-w-[44px] justify-start">
        <NuxtTime
          time-zone="America/Santiago"
          minute="2-digit"
          hour="2-digit"
          :datetime="horaBase.date"
          locale="en-GB"
        />
      </span>
      <template #fallback>
        <span
          class="mb-hora__time flex h-12 min-w-[44px] rounded-xs bg-gray-900"
        ></span>
      </template>
    </ClientOnly>
  </div>
</template>

<script lang="ts" setup>
import { horaState } from '~~/stores/hora';

const horaBase = horaState();

let timeout: NodeJS.Timeout;
const timer = () => {
  return setTimeout(() => {
    horaBase.updateHora();
    timeout = timer();
  }, 10e3);
};

onBeforeMount(() => {
  horaBase.updateHora();
  timeout = timer();
});

onBeforeUnmount(() => {
  clearTimeout(timeout);
});
</script>
